module.exports = __webpack_public_path__ + "img/gift-10-c1.d476f29e.png";